import { ContentfulCityContent } from 'src/../graphql-types';

export const matchCmsCityContentWithPath = (
  cmsContents: ContentfulCityContent[] | undefined,
  browserPath: string | undefined
) =>
  cmsContents
    // get contents where path is included in browserPath
    ?.filter((cityContent) => (cityContent.path ? browserPath?.includes(cityContent.path) : false))
    // when there are more that one path get most specific one (more parameters means greater length)
    .sort((a, b) => a.path?.length || 0 - (b.path?.length || 0))
    .pop();
